var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{class:[_vm.setClases(), {'companies-route-container': _vm.currentRouteName === 'Companies'}],attrs:{"fluid":"","fill-height":"","pa-0":""}},[(_vm.currentRouteName === 'Companies')?[_c('FullHeader',{attrs:{"headerType":2}}),_c('div',{staticClass:"route-view-wrapper"},[_c('router-view')],1)]:_c('router-view')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }